import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'
import { IMotorCarrierDetail } from 'apps/fleet-planner/types'
import { ConfirmationModal, Table, TableCell, TableRow } from 'transfix-ui'

interface IAddTeamMemberModalProps {
  removed: IMotorCarrierDetail[]
  onClose: () => void
  onSuccess: () => void
}

export const RemoveTeamMemberModal: FC<IAddTeamMemberModalProps> = ({
  onClose,
  onSuccess,
  removed,
}) => {
  return (
    <ConfirmationModal
      title='Remove carrier access?'
      size={4}
      open
      onClose={onClose}
      actions={[
        {
          label: 'Go Back',
          type: 'dismiss',
          action: onClose,
        },
        {
          label: 'Remove Access',
          type: 'confirm',
          action: onSuccess,
        },
      ]}>
      <Box>Your team member will no longer be able to view loads from these carriers:</Box>
      <Table>
        {removed.map((carrierDetail: IMotorCarrierDetail) => (
          <TableRow key={carrierDetail.motorCarrierId}>
            <TableCell>{carrierDetail.legalName}</TableCell>
          </TableRow>
        ))}
      </Table>
    </ConfirmationModal>
  )
}
